import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const button: ComponentTemplate = {
  id: "button",
  scope: "left-bar",
  type: "component",
  storeId: null,
  name: "Basic/Button",
  htmlExtractionContext:
    "A button can be a <div> or <a> tag or <button> tag. Common button classnames may be btn, button, btn-*.",
  leftBarCategory: { main: "basic", subCategory: "core" },
  preview: "basic/button.svg",
  template: {
    id: "2f81ea74-9d7d-475b-9123-a73f4b7cc120",
    type: "button",
    props: {
      style: {
        color: "#FFFFFF",
        display: "flex",
        paddingTop: "20px",
        paddingLeft: "32px",
        paddingRight: "32px",
        paddingBottom: "20px",
        backgroundColor: "#000000FF",
        __animateVariantTransitions: true,
      },
    },
    children: [
      {
        id: "ec69f153-92d6-4b74-afce-d6e927d8ba0e",
        type: "text",
        props: {
          text: "<p>This is a button</p>",
          style: {
            letterSpacing: "2px",
            color: "#FFFFFF",
            fontSize: "20px",
            fontWeight: 400,
            lineHeight: "20px",
            flexGrow: 1,
          },
        },
      },
    ],
    // The variants and variant overrides are
    variants: [
      {
        id: "8f722163-2ce4-4209-a905-23ef3e7e7b42",
        name: "default",
        query: null,
        componentOverrides: null,
      },
      {
        query: {
          type: "expression",
          operator: "or",
          statements: [
            {
              id: "0c84f9ce-bef5-4d03-966b-a214ecc6158f",
              field: "interaction.hover",
            },
          ],
        },
        name: "Hover",
        id: "d67eaa4f-e7cd-4015-ab7f-8bc87aa208e7",
        componentOverrides: null,
      },
    ],
    // Variants for different states of the button
    variantOverrides: {
      "d67eaa4f-e7cd-4015-ab7f-8bc87aa208e7": {
        componentOverrides: {
          "2f81ea74-9d7d-475b-9123-a73f4b7cc120": {
            props: {
              style: {
                // The below styles are commented out but they are examples of styles that can be added to the button
                // backgroundColor: "#414141FF",
                // __alchemyGradient__backgroundColor__tilt: null,
                // __alchemyGradient__backgroundColor__stops: null,
                // __reploGradient__color__design_library: null,
                // cursor: "pointer",
                // boxShadow: "0px 4px 4px 0px #00000040",
                // __transform: {
                //   translateX: "0px",
                //   translateY: "0px",
                //   translateZ: "0px",
                //   scaleX: "105%",
                //   scaleY: "105%",
                //   scaleZ: "100%",
                //   rotateX: "0deg",
                //   rotateY: "0deg",
                //   rotateZ: "0deg",
                //   skewX: "0deg",
                //   skewY: "0deg",
                // },
              },
            },
          },
        },
      },
    },
  },
};
